import * as React from 'react';
import useActiveTimeFilters from '../../hooks/use-active-time-filters.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';

const useResetUiStateForNewDateStoreOrTimeFilters = (resetUiState, selectedDate)=>{
    const [{ getAvailabilityTimeFilters  }] = useActiveTimeFilters();
    const [, { store  }] = useAppointmentContext();
    const previousSelectedDate = React.useRef();
    const previousSelectedStore = React.useRef();
    const previousSelectedFilters = React.useRef();
    React.useEffect(()=>{
        var ref, ref1, ref2, ref3;
        const selectedDateChanged = previousSelectedDate.current !== selectedDate;
        const selectedStoreChanged = previousSelectedStore.current !== (store === null || store === void 0 ? void 0 : store.code);
        const { startTime , endTime  } = getAvailabilityTimeFilters(selectedDate);
        const selectedFiltersChanged = ((ref = previousSelectedFilters.current) === null || ref === void 0 ? void 0 : (ref1 = ref.startTime) === null || ref1 === void 0 ? void 0 : ref1.toISOString()) !== (startTime === null || startTime === void 0 ? void 0 : startTime.toISOString()) || ((ref2 = previousSelectedFilters.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.endTime) === null || ref3 === void 0 ? void 0 : ref3.toISOString()) !== (endTime === null || endTime === void 0 ? void 0 : endTime.toISOString());
        if (selectedDateChanged || selectedStoreChanged || selectedFiltersChanged) {
            previousSelectedDate.current = selectedDate;
            previousSelectedStore.current = store === null || store === void 0 ? void 0 : store.code;
            previousSelectedFilters.current = {
                startTime,
                endTime
            };
            resetUiState();
        }
    }, [
        getAvailabilityTimeFilters,
        resetUiState,
        selectedDate,
        store
    ]);
};
var useResetUiStateForNewDateStoreOrTimeFilters$1 = useResetUiStateForNewDateStoreOrTimeFilters;

export { useResetUiStateForNewDateStoreOrTimeFilters$1 as default };
//# sourceMappingURL=useResetUiStateForNewDateStoreOrTimeFilters.js.map
